// extracted by mini-css-extract-plugin
export var box = "_9l-1";
export var checked = "_9l-2";
export var descriptionSpacer = "_9l-9";
export var disabled = "_9l-3";
export var icon = "_9l-6";
export var input = "_9l-0";
export var labelSpacer = "_9l-8";
export var medium = "_9l-5";
export var small = "_9l-4";
export var text = "_9l-7";